import React from 'react';
import LegalDoc from '../components/LegalDoc';

/* Çerez Politikası. İçerik `translations[lang].cookies`.
   Bu site hiç çerez yerleştirmiyor; metin bunu açıkça söylüyor. */
export default function CookiesPage() {
  return <LegalDoc sozlukAnahtari="cookies" parlaklikRengi="rgba(236, 72, 153, 0.3)" />;
}
